<template>
    <div>
        <div class="shadow-box filter-box">
            <!-- 姓名/账号 -->
            <div class="filter-line">
                <div class="title-name">搜索：</div>
                <div class="filter-ipt">
                    <el-input v-model="form.name" prefix-icon="el-icon-search" placeholder="搜索姓名或者账号" clearable @change="fetchData" class="no-border" />
                </div>
            </div>
            <!-- 筛选：用户类型 -->
            <CheckedSelect v-model="form.type" :options="userTypeOptions" label="用户类型" @change="fetchData" />
            <!-- 是否展示 -->
            <div class="filter-line">
                <div class="title-name">是否展示：</div>
                <div style="margin-top: 5px;">
                    <el-radio-group v-model="form.showFlag" @change="fetchData">
                        <el-radio label="">全部</el-radio>
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="0">否</el-radio>
                    </el-radio-group>
                </div>
            </div>
        </div>
        <div class="main-content">
            <div class="item-box" v-for="item in dataList.slice((pageNum - 1) * pageSize, pageNum * pageSize)" :key="item.userId">
                <!-- 更多操作 -->
                <el-popover trigger="hover" placement="bottom">
                    <ul class="corner-operation">
                        <li @click="moreOperation('edit', item)">编辑</li>
                        <li @click="moreOperation('permission', item)">权限设置</li>
                    </ul>
                    <i slot="reference" class="iconfont icon-gengduo more-icon"></i>
                </el-popover>
                <div class="name-line">
                    <div class="name">{{ item.realName }}</div>
                    <div class="blue">{{ item.typeName }}</div>
                    <div class="blue" v-if="item.type == 1" style="background-color: blueviolet;">下级销售：{{ item.childUserIdList ? item.childUserIdList.length : 0 }}</div>
                </div>
                <el-row :gutter="10" style="margin-bottom: 10px;">
                    <el-col :span="10">账号：{{ item.userName }}</el-col>
                    <el-col :span="14">手机号：{{ item.phone }}</el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :span="10">是否展示：<i :class="[item.showFlag == 1 ? 'el-icon-success' : 'el-icon-error', item.showFlag == 1 ? 'green' : 'red']"
                            style="font-size: 20px; vertical-align: text-bottom;"></i></el-col>
                    <el-col :span="14">邮箱：{{ item.email }}</el-col>
                </el-row>
            </div>
        </div>
        <pagination v-if="dataList.length" :total="dataList.length" :page.sync="pageNum" :limit.sync="pageSize" :pageSizes="[9, 18, 36, 72]" style="margin-top: 20px;" />
        <!-- 空数据 -->
        <div class="empty-wrap" v-else>
            <img src="@/assets/image/emptyBlue.png" alt="">
        </div>

        <!-- 新增/编辑 -->
        <el-drawer :title="`${editId ? '编辑' : '新增'}用户`" :visible.sync="addEditDrawer" size="35rem" direction="rtl" :wrapperClosable="false" custom-class="add-drawer">
            <el-form ref="addEditFormRef" :model="addEditForm" :rules="addEditRules" label-position="left" label-width="100px">
                <el-form-item label="姓名" prop="realName">
                    <el-input v-model="addEditForm.realName" placeholder="请输入真实姓名" clearable></el-input>
                </el-form-item>
                <el-form-item label="账号" prop="userName">
                    <el-input v-model="addEditForm.userName" placeholder="请输入账号名" clearable></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="password">
                    <el-input v-model="addEditForm.password" placeholder="请输入密码" clearable></el-input>
                </el-form-item>
                <el-form-item label="用户类型" prop="type">
                    <el-select v-model="addEditForm.type" placeholder="请选择用户类型" filterable clearable style="width: 100%">
                        <el-option v-for="item in userTypeOptions.slice(1)" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="下级销售">
                    <el-select v-model="addEditForm.childUserIdList" placeholder="请选择" filterable clearable multiple style="width: 100%">
                        <el-option v-for="item in childUserOption" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="手机号" prop="phone">
                    <el-input v-model="addEditForm.phone" placeholder="请输入手机号" clearable></el-input>
                </el-form-item>
                <el-form-item label="邮箱" prop="email">
                    <el-input v-model="addEditForm.email" placeholder="请输入邮箱" clearable></el-input>
                </el-form-item>
                <el-form-item label="是否展示" prop="showFlag">
                    <el-radio-group v-model="addEditForm.showFlag">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="0">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="">
                    <el-button :loading="loadSave" @click="confirmAddEdit" class="save-btn">保存</el-button>
                </el-form-item>
            </el-form>
            <drawer-close :visible="addEditDrawer" right="35rem" @close="addEditDrawer = false"></drawer-close>
        </el-drawer>

        <!-- 权限设置 -->
        <el-dialog title="权限设置" :visible.sync="permissionDialog" width="1000px" top="10vh" :close-on-click-modal="false">
            <el-table :data="permissionData" row-key="id" :tree-props="{children: 'subMenu'}" :header-cell-style="{'background-color': '#F2F3F5', 'color': '#333' }"
                v-loading="loadPermission">
                <el-table-column prop="name" label="功能" min-width="100" align="left">
                    <template slot-scope="{row}">
                        <span v-if="row.level == 1 && !(row.subMenu && row.subMenu.length)" class="block"></span>{{ row.name }}
                    </template>
                </el-table-column>
                <el-table-column prop="actionList" label="操作" min-width="200" align="center">
                    <template slot-scope="{row}">
                        <el-checkbox-group v-model="row.activeIds" @change="checkedGroupChange($event, row)" v-if="row.actionList && row.activeIds">
                            <el-checkbox :label="item.id" v-for="item in row.actionList" :key="item.id">{{ item.name }}</el-checkbox>
                        </el-checkbox-group>
                    </template>
                </el-table-column>
                <el-table-column prop="checkedAll" label="全选" min-width="100" align="center">
                    <template slot-scope="{row}">
                        <el-checkbox v-model="row.checkedAll" @change="checkedAllChange($event, row)">全选</el-checkbox>
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer">
                <el-button @click="permissionDialog = false">取 消</el-button>
                <el-button type="primary" :loading="loadConfirm" @click="confirmPermission">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { findUserListByCondition, addUser, updateUser, findUserMenuRelList, updateUserMenuRel } from '@/api/setting/index.js';
import { findUserListByType } from '@/api/home/public.js';
import { mapState } from 'vuex';

export default {
    name: "userManage",
    data() {
        const noChinese = (rule, value, callback) => {
            if (value) {
                if (/[\u4E00-\u9FA5]/g.test(value)) {
                    callback(new Error('不能输入汉字!'));
                } else {
                    callback();
                }
            }
            callback();
        };
        return {
            loadAll: false,
            form: {
                name: '',
                type: '',
                showFlag: '',
            },
            dataList: [],
            pageNum: 1,
            pageSize: 9,
            // 新增/编辑
            addEditDrawer: false,
            editId: '',
            addEditForm: {
                realName: '',
                userName: '',
                password: '',
                type: '',
                childUserIdList: [],
                phone: '',
                email: '',
                showFlag: '',
            },
            addEditRules: {
                realName: [{ required: true, message: "请输入真实姓名", trigger: "blur" }],
                userName: [
                    { required: true, message: "请输入账号名", trigger: "blur" },
                    { pattern: /^[a-zA-Z]+$/, message: "只能输入英文字母", trigger: "blur" }
                ],
                password: [
                    { required: false, message: "请输入密码", trigger: "blur" },
                    { validator: noChinese, trigger: 'blur' }
                ],
                type: [{ required: true, message: "请选择用户类型", trigger: "blur" }],
                email: [{ pattern: /^([a-zA-Z0-9-])+@([a-zA-Z0-9-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/, message: "请输入正确的邮箱格式", trigger: "blur" }],
                phone: [{ pattern: /^1[3-9]\d{9}$/, message: "请输入正确的手机号", trigger: "blur" }],
                showFlag: [{ required: true, message: "请选择是否展示", trigger: "blur" }],
            },
            childUserOption: [],
            loadSave: false,
            // 权限设置
            permissionDialog: false,
            permissionData: [],
            loadPermission: false,
            loadConfirm: false,
        }
    },
    computed: {
        ...mapState(['userTypeOptions', 'userData'])
    },
    created() {
        this.fetchUserListByType()
        this.fetchData();
    },
    methods: {
        // 查找区域经理的下拉列表
        fetchUserListByType() {
            findUserListByType(0).then(res => {
                this.childUserOption = res.data
            }).catch(() => {
                this.childUserOption = []
            })
        },
        // 获取用户列表数据
        fetchData() {
            this.loadAll = true;
            findUserListByCondition(this.form).then(res => {
                this.dataList = res.data;
                this.loadAll = false;
            }).catch((err) => {
                this.loadAll = false;
                this.$MessageBox.MessageWarning(err.data.msg);
            });
        },
        moreOperation(type, item) {
            if (type == "edit") {
                this.addEditDrawer = true;
                this.editId = item.userId;
                this.addEditForm = {
                    realName: item.realName,
                    userName: item.userName,
                    password: '',
                    type: item.type.toString(),
                    childUserIdList: item.childUserIdList,
                    phone: item.phone,
                    email: item.email,
                    showFlag: item.showFlag,
                };
                this.addEditRules.password[0].required = false;
                this.$nextTick(() => {
                    this.$refs.addEditFormRef?.clearValidate();
                })
            } else if (type == "add") {
                this.addEditDrawer = true;
                this.editId = "";
                this.addEditForm = {
                    realName: '',
                    userName: '',
                    password: '',
                    type: '',
                    childUserIdList: [],
                    phone: '',
                    email: '',
                    showFlag: '',
                };
                this.addEditRules.password[0].required = true;
                this.$nextTick(() => {
                    this.$refs.addEditFormRef?.clearValidate();
                })
            } else if (type == "permission") {
                this.permissionDialog = true;
                this.editId = item.userId;
                this.fetchPermissionData();
            }
        },
        // 确认新增/编辑用户
        confirmAddEdit() {
            this.loadSave = true;
            this.$refs.addEditFormRef.validate(valid => {
                if (valid) {
                    let req = this.editId ? updateUser : addUser;
                    req({
                        userId: this.editId ? this.editId : undefined,
                        ...this.addEditForm,
                        password: this.addEditForm.password ? this.$utils.md5Password(this.addEditForm.password) : undefined,
                    }).then(res => {
                        this.loadSave = false;
                        this.addEditDrawer = false;
                        this.fetchData();
                        this.$MessageBox.MessageSuccess(res.msg);
                        this.$store.dispatch("loadUserList");
                    }).catch((err) => {
                        this.loadSave = false;
                        this.$MessageBox.MessageWarning(err.data.msg);
                    });
                } else {
                    this.loadSave = false;
                    return;
                }
            })
        },
        // 获取用户权限数据
        fetchPermissionData() {
            this.loadPermission = true;
            findUserMenuRelList({ userId: this.editId }).then(res => {
                this.permissionData = [];
                res.data.forEach(item => {
                    item.level = 1;
                    this.$set(item, "activeIds", item.userActionList.map(x => x.id) || []);
                    this.$set(item, "checkedAll", item.actionList.length === item.userActionList.length);
                    if (item.subMenu && item.subMenu.length) {
                        item.subMenu = childData(item.subMenu);
                    }
                    this.permissionData.push(item);
                })
                this.loadPermission = false;
            }).catch((err) => {
                this.loadPermission = false;
                this.permissionData = [];
                this.$MessageBox.MessageWarning(err.data.msg);
            });

            let _thit = this;
            function childData(data) {
                let arr = [];
                data.forEach(item => {
                    _thit.$set(item, "activeIds", item.userActionList.map(x => x.id) || []);
                    _thit.$set(item, "checkedAll", item.actionList.length === item.userActionList.length);
                    if (item.subMenu && item.subMenu.length) {
                        item.subMenu = childData(item.subMenu);
                    }
                    arr.push(item);
                })
                return arr;
            }
        },
        checkedAllChange(val, row) {
            if (val) {
                this.$set(row, "activeIds", row.actionList.map(x => x.id) || []);
            } else {
                this.$set(row, "activeIds", []);
            }
        },
        checkedGroupChange(val, row) {
            this.$set(row, "checkedAll", row.actionList.length === row.activeIds.length);
        },
        // 确定编辑权限
        confirmPermission() {
            this.loadConfirm = true;
            let menuModelList = [];
            this.permissionData.forEach(item => {
                let temp = {
                    id: item.id,
                    userActionList: item.activeIds.map(x => { return { id: x } }),
                    subMenu: [],
                };
                if (item.subMenu && item.subMenu.length) {
                    temp.subMenu = this.handleChildData(item.subMenu);
                }
                menuModelList.push(temp);
            })
            updateUserMenuRel({
                userId: this.editId,
                menuModelList,
            }).then(res => {
                this.loadConfirm = false;
                this.permissionDialog = false;
                this.$MessageBox.MessageSuccess(res.msg);
            }).catch((err) => {
                this.loadConfirm = false;
                this.$MessageBox.MessageWarning(err.data.msg);
            });
        },
        handleChildData(data) {
            let arr = [];
            data.forEach(item => {
                let temp = {
                    id: item.id,
                    userActionList: item.activeIds.map(x => { return { id: x } }),
                    subMenu: [],
                };
                if (item.subMenu && item.subMenu.length) {
                    temp.subMenu = this.handleChildData(item.subMenu);
                }
                arr.push(temp);
            })
            return arr;
        },
    }
}
</script>

<style lang="scss" scoped>
.filter-box {
    position: relative;
    margin: 16px 0 24px;
    padding: 20px 1.38rem;
    /deep/ .filter-line {
        display: flex;
        &:not(:last-of-type) {
            margin-bottom: 8px;
        }
        .title-name {
            min-width: 6rem;
            padding-top: 5px;
            white-space: nowrap;
        }
        .filter-ipt {
            width: 40%;
            border-radius: 1.6rem;
            box-shadow: 0 0.06667rem 0.4rem 0.06667rem rgba(0, 0, 0, 0.1);
            overflow: hidden;
            padding: 0 0.6rem;
            > .el-input {
                .el-input__inner {
                    height: 2.2rem;
                    line-height: 2.2rem;
                }
                .el-input__icon {
                    line-height: 2.2rem;
                }
            }
        }
    }
}
.main-content {
    display: flex;
    flex-wrap: wrap;
    gap: 21px 18px;
    .item-box {
        position: relative;
        width: calc(100% / 3 - 12px);
        min-width: 20rem;
        padding: 1.38rem;
        background-color: #fff;
        border-radius: 12px;
        box-shadow: 0px 1px 0.75rem 1px rgba(4, 32, 93, 0.09);
        box-sizing: border-box;
        .more-icon {
            position: absolute;
            right: 1.38rem;
            top: 0.5rem;
            font-size: 1.8rem;
            cursor: pointer;
        }
        .name-line {
            font-weight: 550;
            display: flex;
            align-items: center;
            gap: 0.5rem;
            margin-bottom: 10px;
            .name {
                font-size: 1.25rem;
            }
            .blue {
                display: inline-block;
                padding: 0 7px;
                height: 20px;
                line-height: 20px;
                color: #ffffff;
                background-color: #4673da;
                border-radius: 4px;
                font-size: 0.8rem;
                font-weight: 400;
            }
        }
        /deep/ .el-row {
            color: $primary-font-color;
            .el-col {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
    }
    /* 去除每行尾的多余边距 */
    .item-box:nth-child(3n) {
        margin-right: 0;
    }
}
.empty-wrap {
    padding-top: 50px;
    text-align: center;
    > img {
        width: 460px;
    }
}
.operate {
    text-align: center;
    line-height: 2;
    div {
        cursor: pointer;
    }
}
.block {
    display: inline-block;
    width: 22px;
}
.save-btn {
    width: 6.9rem;
    height: 2.38rem;
    background: $primary-btn-color;
    color: #fff;
    border: none;
    border-radius: 6px;
    display: inline-block;
    margin: 0.5rem 0 3rem;
    cursor: pointer;
}
.green {
    color: #56b562;
}
.red {
    color: #f56c6c;
}
</style>